import React from 'react';
import { Badge } from '../ui/Badge';
import { InspectionResult } from '../../types/inspection';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';

interface InspectionResultBadgeProps {
  result: InspectionResult;
  className?: string;
}

export const InspectionResultBadge: React.FC<InspectionResultBadgeProps> = ({ result, className }) => {
  const config = {
    pass: { label: 'Pass', variant: 'success' as const, icon: <CheckCircle2 className="w-3 h-3" /> },
    fail: { label: 'Fail', variant: 'danger' as const, icon: <XCircle className="w-3 h-3" /> },
    partial: { label: 'Partial', variant: 'warning' as const, icon: <AlertTriangle className="w-3 h-3" /> },
  };

  const { label, variant, icon } = config[result];

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {icon}
      <Badge label={label} variant={variant} />
    </span>
  );
};
